export const getClinicalSite = [
    { value: "all", label: "All" },
    { value: "option1", label: "Option 1" },
    { value: "option 2", label: "Option 2" },
    { value: "option3", label: "Option 3" },
]

export const getLocations = [
    { value: "all", label: "All" },
    { value: "option1", label: "Option 1" },
    { value: "option 2", label: "Option 2" },
    { value: "option3", label: "Option 3" },
]

export const getAgeRange = [
    { value: "lessThan12", label: "Less than 12 Years" },
    { value: "12To18", label: "12 to 18 Years" },
    { value: "19To30", label: "19 to 30 Years" },
    { value: "31To40", label: "31 to 40 Years" },
    { value: "41To50", label: "41 to 50 Years" },
    { value: "51To60", label: "51 to 60 Years" },
    { value: "61To70", label: "61 to 70 Years" },
    { value: "71To80", label: "71 to 80 Years" },
    { value: "81To90", label: "81 to 90 Years" },
    { value: "90+", label: "90 + Years" },
]

export const getStatus = [
    {value: 'active', label: 'Active'},
    {value: 'archived', label: 'Archived'}
]

export const careTypes = [
    {value: 'INDIVIDUAL', label: 'Individual Provider Care Plan'},
    {value: 'COLLABORATIVE', label: 'Collaborative Care Plan'}
]

export const careMeeting = [
    {value: 'Discharge', label: 'Discharge Planning'},
    {value: 'Family', label: 'Family Case Conference'},
    {value: 'Weekly', label: 'Weekly Conference Rounds'},
]

export const functionIssues = [
    {
        id: 1,
        intervention: [1]
    }
]    
export const editEmailType = [
    {
        value:'home', label: 'Home'
    },
    {
        value:'work', label: 'Work'
    }
] 
export const editPhoneNumberType = [
    {
        value:'home', label: 'Home'
    },
    {
        value:'work', label: 'Work'
    },
    {
        value:'mobile', label: 'Mobile'
    }
]
export const editMailingAddress = [
    {
        value:'home', label: 'Home'
    },
    {
        value:'work', label: 'Work'
    }
]                                                                                                                                                                                                                                                                                                                                                                           
export const getClinicalSiteType = [
    { value: "all", label: "All" },
    {
        value: 'clinicalSitetype', label: 'Ambulatory Healthcare Services'
    },
    {
        value: 'hospital', label: 'Hospital'
    },
    {
        value: 'nursing', label: 'Nursing & Residential Care Facility'
    }

]
export const getClinicalSiteCities = [
    {value: 'ottawa', label:'Ottawa'}
]
export const getClinicalSiteCountries = [
    {value: 'canada', label:'Canada'},
    {value: 'usa', label: 'United States'}
]